export default {
  getTipoArchivos: state => state.tipoArchivos,
};
